import { TelephoneCountryCodeDto } from 'api';

import { IdLabelDto } from '../Common/IdLabelDto';

export const mapTelephoneCountryCodeToIdLabel = ({
	shortCountryCode,
	countryName,
	telephoneCode,
}: TelephoneCountryCodeDto): IdLabelDto => ({
	id: shortCountryCode,
	label: `${telephoneCode} (${countryName})`,
});
